export default "__VITE_ASSET__29Z_kMnD__"